const MainLayout = ({ children }) => {
  return (
    <div className="shadow-custom-soft md:p-5 p-3 rounded-lg bg-background text-darkText h-full overflow-auto relative flex flex-col justify-between">
      {children}
    </div>
  );
};

export default MainLayout;
